<template>
  <b-row v-if="parentPath && path">
    <b-col md="12">
      <!--  :header="uniTranslation('S876')" -->
      <b-card class="card-panel" :style="{ backgroundColor: coloreSfondo }">
        <div class="row">
          <div class="col-xl-6 col-lg-12">
            <UnidataEditorCorrelator :parent-path="path" group="CoilsGroup">
            </UnidataEditorCorrelator>

            <div>
              <UnidataEditor :parent-path="path" :name="'.rowsNumber'" :decimal-number="0">
              </UnidataEditor>
            </div>

            <div>
              <UnidataEditor :parent-path="path" :name="'.skippedTubesNumber'" :decimal-number="0">
              </UnidataEditor>
            </div>
          </div>

          <div class="col-xl-6 col-lg-12">
            <div>
              <UnidataEditor :parent-path="path" :name="'.finnedLength'"> </UnidataEditor>
            </div>

            <div>
              <UnidataEditor :parent-path="path" :name="'.circuitsNumber'" :decimal-number="0">
              </UnidataEditor>
            </div>

            <div>
              <UnidataEditor :parent-path="path" :name="'.bafflesNumber'" :decimal-number="0">
              </UnidataEditor>
            </div>
          </div>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import UnidataEditorCorrelator from "../unidata/UnidataEditorCorrelator";
import UnidataEditor from "../unidata/UnidataEditor";
// import { Select, Option, Collapse, CollapseItem } from "element-ui";
// import jsonHelper from "../../shared/jsonHelper";
import { mapGetters } from "vuex";

export default {
  components: {
    UnidataEditorCorrelator,
    UnidataEditor /*,
    "el-select": Select,
    "el-option": Option,
    "el-collapse": Collapse,
    "el-collapse-item": CollapseItem*/
  },
  props: {
    parentPath: {
      type: String,
      required: true
    },
    localPath: {
      type: String,
      required: true
    }
    // projectModality:{
    //   type: Number,
    //   required: true
    // },
    // projectType:{
    //   type: String,
    //   required: true
    // }
  },
  data() {
    return {
      path: null,
      coloreSfondo: ""
    };
  },
  computed: {
    ...mapGetters("_prjModule", ["projects"]),
    ...mapGetters("_colorsModule", ["cardColors"])
  },
  watch: {
    parentPath: function(nv /*, ov*/) {
      if (nv !== undefined && nv !== null && nv !== "") {
        this.path = this.parentPath + this.localPath;
      }
    }
  },
  mounted: function() {
    if (this.parentPath && this.localPath) this.path = this.parentPath + this.localPath;
    var that = this;
    that.coloreSfondo = that.cardColors[0] + " !important";
  },
  methods: {}
};
</script>

<style lang="scss">
.no-border-bottom {
  div {
    .el-collapse-item__header {
      border-bottom: none;
    }
  }
}
</style>
